export type ChatKeySource = 'user' | 'workspace' | 'server' | 'none';

export type ChatKeysCheckReason =
  | 'no_server_keys'
  | 'server_key_decryption_failed'
  | 'free_plan'
  | 'disabled'
  | 'suspended'
  | 'unknown'
  | null;

export interface ChatKeysCheckData {
  hasKeys: boolean;
  source: ChatKeySource;
  providers: string[];
  reason: ChatKeysCheckReason;
  isOwner: boolean;
}

const getChatKeysCheckUrl = (workspaceId: string) =>
  workspaceId
    ? `/api/copilot/user-keys/check-chat-keys?workspaceId=${encodeURIComponent(workspaceId)}`
    : '/api/copilot/user-keys/check-chat-keys';

export function fetchChatKeysCheck(
  workspaceId: string
): Promise<ChatKeysCheckData> {
  const url = getChatKeysCheckUrl(workspaceId);
  return workspaceApiFetch(
    url,
    { credentials: 'include' },
    {
      workspaceId,
      category: 'ai-bootstrap',
      mode: 'background',
      priority: 'visible',
    }
  ).then(async res => {
    if (!res.ok) {
      throw new Error(`Failed to check chat keys: HTTP ${res.status}`);
    }
    const data = (await res.json()) as Partial<ChatKeysCheckData>;
    return {
      hasKeys: data.hasKeys ?? false,
      source: data.source ?? 'none',
      providers: data.providers ?? [],
      reason: data.reason ?? null,
      isOwner: data.isOwner ?? false,
    };
  });
}
import { workspaceApiFetch } from '@affine/core/modules/cloud';
